<template>
  <div class="gaoya">
    <!-- <img src="../../../assets/images/shipin.png" /> -->
    <div class="video-left-box" v-loading="listLoading">
      <div class="video-info">
        <p class="video-title">设备列表（{{ total }}）</p>
        <el-row type="flex">
          <el-col :span="12"><span class="video-span">在线：</span>
            <span class="video-on">{{ normal }} </span>
          </el-col>
          <el-col :span="12"><span class="video-span">离线：</span>
            <span class="video-off">{{ abnormal }} </span>
          </el-col>
        </el-row>
      </div>
      <ul class="video-list">
        <span v-if="videoList.length === 0" class="nodata">暂无数据</span>
        <li v-for="(item, index) in videoList" class="text-one" :title="item.name" :class="index === activeIndex ? 'is-active' : ''" @click="videoClick(item, index)" :key="index">
          {{ item.videoName }}
        </li>
      </ul>
    </div>
    <div class="video-right-box">
      <div class="nodata-box" v-loading="listLoading" v-if="iframeUrl === ''">
        <span>暂无数据</span>
      </div>
      <iframe v-else :src="iframeUrl" width="100%" height="750" id="ysOpenDevice" allowfullscreen>
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      videoList: [],
      getAccessToken: "",
      nowdata: "",
      listLoading: false,
      // time:'',
      // &accessToken=${this.getAccessToken}&begin=${row.startTime}&end=${row.endTime}`
      iframeUrl: "",
      switchValue: true,
      abnormal: "",
      normal: "",
      total: "",
      projectId: "",
    };
  },
  props: {
    msg: String,
  },
  computed: {
    roomId() {
      return this.$store.state.roomId;
    },
  },
  mounted() {
    this.projectId = this.$getCookie("projectId");
    // alert(localStorage.getItem('accessToken'))
    this.getAccessToken = localStorage.getItem("accessToken");
    // this.getAccessToken='at.5m4jbfj05z94x48obzkxj3yl8wqqyps6-4jmlqox6zh-0jqyz19-1teviqv3h'
    console.log(this.getAccessToken);
    this.nowdata = this.$formatDate("yyyyMMdd", new Date());
    this.getEquipmentVideoList();
    this.getVideoStatisticsVo();
  },
  watch: {
    roomId() {
      this.getEquipmentVideoList();
      this.getVideoStatisticsVo();
    },
  },

  methods: {
    videoClick(item, index) {
      this.activeIndex = index;
      this.loadVideo(item);
    },
    loadVideo(item) {
      this.iframeUrl = `https://open.ys7.com/ezopen/h5/iframe_se?url=${item.videoUrl}&autoplay=1&accessToken=${this.getAccessToken}&begin=${this.nowdata}&end=${this.nowdata}`;
    },
    getEquipmentVideoList() {
      // let roomId = this.$getCookie("roomId");
      this.iframeUrl = "";
      if (!this.roomId) {
        return false;
      } else {
        this.videoList = [];
        this.$http
          .post("bma-distribution-service/video/getEquipmentVideoList", {
            projectId: this.projectId,
            roomId: this.roomId,
          })
          .then((res) => {
            if (res.data.length > 0) {
              this.videoList = res.data;
              setTimeout(() => {
                this.iframeUrl = `https://open.ys7.com/ezopen/h5/iframe_se?url=${this.res.data[0].videoUrl}&autoplay=1&accessToken=${this.getAccessToken}&begin=${this.nowdata}&end=${this.nowdata}`;
              }, 500);
            } else {
              this.iframeUrl = "";
              this.videoList = [];
            }
          });
      }
    },
    getVideoStatisticsVo() {
      // let roomId = this.$getCookie("roomId");
      if (!this.roomId) {
        return false;
      } else {
        this.videoList = [];
        this.listLoading = true;
        this.$http
          .post("bma-distribution-service/video/getVideoStatisticsVo", {
            projectId: this.projectId,
            roomId: this.roomId,
          })
          .then((res) => {
            this.abnormal = res.data.abnormal;
            this.normal = res.data.normal;
            this.total = res.data.total;
            this.listLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nodata {
  text-align: center;
  margin-top: 14px;
  // background: #fff!important;
  margin-top: 0px;
  height: 50px;
  line-height: 50px;
  margin-left: 30%;
}
.gaoya {
  margin-top: -15px;
  .video-left-box {
    width: 229px;
    line-height: 30px;
    display: inline-block;
    height: 100%;
    // height: 750px;
    overflow: auto;
  }
  .video-right-box {
    width: calc(100% - 230px);
    position: absolute;
    top: 105px;
    left: 230px;
    height: 100%;
    img {
      height: 745px;
      width: 100%;
    }
  }

  .video-info {
    background: #f2f2f2;
    font-size: 15px;
    padding: 0px 15px 10px 24px;
    .video-title {
      font-weight: 600;
      line-height: 30px;
      color: #0e223d;
      padding-top: 10px;
    }
    .video-span {
      color: #0e223d;
    }
    .video-on {
      color: #1460e0;
    }
    .video-off {
      color: #898989;
    }
  }
  .nodata-box {
    height: 750px;
    width: 1433px;
    background: #000;
    span {
      color: #fff;
      text-align: center;
      font-size: 24px;
      position: absolute;
      top: 50%;
      left: 47%;
    }
  }
  .video-list {
    li {
      height: 51px;
      line-height: 51px;
      padding-left: 24px;
      color: #0e223d;
      max-width: 180px;
      &:hover,
      &.is-active {
        color: #1460e0;
        background: linear-gradient(
          90deg,
          rgba(20, 96, 224, 0.06) 0%,
          rgba(20, 96, 224, 0) 100%
        );
      }
    }
  }
}
</style>
